<template>

  <div>
    <!-- Dialog for show Informations of the Clients -->
    <v-dialog v-model="showDetails" max-width="900" persistent>
      <v-card>
        <v-toolbar color="white" class="elevation-1" card>
          <v-toolbar-title class="headline font-weight-light">{{dynamicDetailsTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn color="error" title="Fechar" icon round flat @click="closeDialog('details')">
              <v-icon color="error" large>clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div v-if="!isPhysical">
          <!-- For Companies (cnpj) -->
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="CNPJ" v-model="legalDetails.cnpj" box readonly return-masked-value
                    mask="##.###.###/####-##"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Razão Social" v-model="legalDetails.socialName" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Nome Fantasia" v-model="legalDetails.fatansyName" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="E-mail" type="email" v-model="legalDetails.email" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Telefone" v-model="legalDetails.phone" box readonly mask="(##) ####-####">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="CEP" v-model="legalDetails.address.cep" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Logradouro" v-model="legalDetails.address.addressType" box readonly>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Complemento" v-model="legalDetails.address.complement" box readonly>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-text-field label="Número" v-model="legalDetails.address.number" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Bairro" v-model="legalDetails.address.district" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Cidade" v-model="legalDetails.address.city" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field class="no-text-transform" label="Estado 2" v-model="legalDetails.address.state" box
                    readonly></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </div>
        <div v-else>
          <!-- For physical people (cpf) -->
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field label="CPF" v-model="physicalDetails.cpf" box readonly return-masked-value
                    mask="###.###.###-##"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="RG" v-model="physicalDetails.rg" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Nome" v-model="physicalDetails.name" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  
                  <v-text-field label="E-mail" type="email" v-model="physicalDetails.email" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Telefone Celular" v-model="physicalDetails.phone" box readonly mask="(##) #####-####">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="CEP" v-model="physicalDetails.address.cep" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Logradouro" v-model="physicalDetails.address.addressType" box readonly>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Complemento" v-model="physicalDetails.address.complement" box readonly>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-text-field label="Número" v-model="physicalDetails.address.number" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Bairro" v-model="physicalDetails.address.district" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Cidade" v-model="physicalDetails.address.city" box readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field class="no-text-transform" label="Estado" v-model="physicalDetails.address.state" box
                    readonly></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>

    <v-toolbar flat>
      <v-toolbar-title class="headline font-weight-light">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <!-- Dialog to register a new Client -->
      <v-dialog v-model="dialog" max-width="700px" persistent>
        <v-btn :loading="loading" :disabled="loading" slot="activator" color="info" icon round
          title="Inserir um novo registro">
          <v-icon>add</v-icon>
        </v-btn>

        <v-card>

          <v-toolbar color="white" class="elevation-3" card>
            <v-toolbar-title class="headline font-weight-light">
              {{ formTitle }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-switch v-if="physical && physical.active != undefined || null" class="pt-switch"
                v-model="physical.active" title="Ativar/Desativar o registro"></v-switch>
              <v-switch v-if="validCnpj && validCnpj.active != undefined || null && isValidCnpj" class="pt-switch"
                v-model="validCnpj.active" title="Ativar/Desativar o registro"></v-switch>
              <v-btn color="error" icon round flat :disabled="loading" title="Cancelar">
                <v-icon @click="closeDialog('person');" color="error" large>clear</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <div>
            <v-alert v-model="validationAlert" class="font-weight-light" dismissible outline type="error"
              style="border: none;">
              {{ validationMessage }}
            </v-alert>
          </div>
          <v-form ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-xl v-if="!isEditing">
                <v-layout wrap row>
                  <v-layout wrap row>
                    <v-flex xs12>
                      <v-select box :items="tipos" label="Tipo de Pessoa (Física/Jurídica)" v-model="tipo"
                        @change="setPersonType();"></v-select>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
              <v-container v-if="isPhysical === 0" fluid grid-list-xl>
                <!-- Physical (cpf) -->
                <v-layout wrap row>
                  <v-flex xs12>
                    <v-text-field box v-model="physical.cpf" label="CPF" :rules="inputRules" return-masked-value
                      mask="###.###.###-##">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field box v-model="physical.rg" :rules="inputRules" label="RG"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field box v-model="physical.name" :rules="inputRules" label="Nome"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field box v-model="physical.email" :rules="emailRules" label="E-mail" type="email">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field class="no-text-transform" label="Telefone Celular" v-model="physical.phone" box
                      mask="(##) #####-####"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                    <v-subheader>Endereço (opcional)</v-subheader>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field label="CEP" v-model="physical.address.cep" box @input="findAddressByCep"
                      mask="##.###-###"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field label="Logradouro" v-model="physical.address.addressType" box :disabled="loadingCEP">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field label="Complemento" v-model="physical.address.complement" box></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field label="Número" v-model="physical.address.number" box></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field label="Bairro" v-model="physical.address.district" box :disabled="loadingCEP">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field label="Cidade" v-model="physical.address.city" box :disabled="loadingCEP">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field class="no-text-transform" label="Estado" v-model="physical.address.state" box
                      :disabled="loadingCEP"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container v-if="isPhysical === 1" fluid grid-list-xl>
                <!--  -->
                <v-layout wrap row>
                  <v-layout wrap row>
                    <v-flex :class="isEditing ? 'xs12' : 'xs10'">
                      <v-text-field box v-model="cnpj.cnpj" label="CNPJ" :readonly="isEditing" return-masked-value
                        mask="##.###.###/####-##">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="!isEditing">
                      <v-tooltip bottom>
                        <v-btn slot="activator" color="primary" fab small dark @click="searchCnpj();">
                          <v-icon>search</v-icon>
                        </v-btn>
                        <span>Buscar CNPJ</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="isValidCnpj" wrap row>
                    <!-- Companies (cnpj) -->
                    <v-flex xs12 sm6>
                      <v-text-field box v-model="validCnpj.socialName" label="Razão Social">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field box v-model="validCnpj.fantasyName" label="Nome Fantasia"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                      <v-subheader>Endereço (opcional)</v-subheader>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field box v-model="validCnpj.address.addressType" label="Logradouro"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-text-field box v-model="validCnpj.address.complement" label="Complemento"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm2>
                      <v-text-field box v-model="validCnpj.address.number" label="Número"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field box v-model="validCnpj.address.cep" label="CEP"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field box v-model="validCnpj.address.district" label="Bairro"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field box v-model="validCnpj.address.city" label="Município"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field box v-model="validCnpj.address.state" label="UF"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field box v-model="validCnpj.email" :rules="emailRules" label="E-mail" type="email">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field box v-model="validCnpj.phone" label="Telefone" class="no-text-transform" mask="(##) ####-####">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions class="actions-padding">
              <v-btn color="success lighten-1" round block :disabled="loading" @click="save();">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>

      </v-dialog>
    </v-toolbar>

    <v-data-table :loading="loading" :headers="headers" :search="search" :items="persons" class="elevation-1"
      rows-per-page-text="Registros por Página" :rows-per-page-items="[10, 30, 50, 100]">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.cpf ? props.item.name : props.item.socialName }}</td>
        <td class="text-xs-center">{{ props.item.cpf ? "Física" : "Jurídica" }}</td>
        <td class="text-xs-center">{{ props.item.cpf ? props.item.cpf : props.item.cnpj }}</td>
        <td class="text-xs-center">{{ props.item.email }}</td>
        <td class="text-xs-center">
          <v-chip small class="white--text font-weight-light"
            :color="props.item.active == false ? 'error' : 'success lighten-1' " :disabled="props.item.active == false">
            {{props.item.active == false ? 'Inativo' : 'Ativo'}}</v-chip>
        </td>
        <td class="justify-center layout px-0">
          <v-btn color="info" round flat icon @click="edit(props.item)" title="Editar registro" :disabled="loading">
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn color="info" round flat icon @click="details(props.item)" title="Informações sobre registro"
            :disabled="loading">
            <v-icon>info</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="pageText" slot-scope="props">
        {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
      <template slot="no-data">
        <strong> {{emptyRecordsText}} </strong>
      </template>
      <div slot="no-results" :value="true">
        <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
      </div>
    </v-data-table>

    <v-layout row justify-center>
      <v-dialog v-model="dialogRemove" max-width="500">
        <v-card>
          <v-toolbar color="white" class="elevation-1" card>
            <v-toolbar-title class="font-weight-light headline">Excluir Cliente</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn @click="dialogRemove = false" title="Cancelar" round icon color="error">
                <v-icon>clear</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <span v-if="personRemove.cpf">Cliente: {{ personRemove.name }}</span>
            <span v-else>Razão social: {{ personRemove.socialName }}</span>
            <span v-if="personRemove.cpf">CPF: {{ personRemove.cpf }}</span>
            <span v-else>CNPJ: {{ personRemove.cnpj }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click="remove();">
              Sim
            </v-btn>
            <v-btn color="green darken-1" flat="flat" @click="dialogRemove = false">
              Não
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line :timeout="snackbar.timeout" vertical right
      button>
      <strong>{{snackbar.title}}</strong> {{ snackbar.subtitle }}
      <v-btn dark flat @click="snackbar.visible = false">
        Fechar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import PersonService from "../service/PersonService";
  import PhysicalPersonForm from "../components/PhysicalPersonForm";
  import LegalPersonForm from "../components/LegalPersonForm";
  import Converter from "../utils/LegalPersonConverter";
  import UtilService from "../service/UtilService.js";

  export default {
    components: {
      PhysicalPersonForm,
      LegalPersonForm
    },

    data: () => ({
      search: '',
      /**********\
      ***Visual***
      \**********/
      switch1: true,
      loading: false,
      validationAlert: false,
      dialog: false,
      dialogRemove: false,
      showDetails: false,
      disabledButtonSave: true,
      /*********\
      ***Textos**
      \*********/
      validationMessage: "",
      title: "Listagem de Clientes",
      buttonTitle: "Novo",
      textDeletedData: "Pessoa excluída com sucesso",
      footerText: "Total de registos: ",
      emptyRecordsText: "Nenhum registro encontrado",
      detailsTitlePhysical: "Detalhes",
      detailsTitleLegal: "Detalhes Jurídicos",
      editingLegalRegisterTitle: "Editar Cliente",
      newLegalRegisterTitle: "Novo Cliente",
      editingPhysicalRegisterTitle: "Editar Cliente",
      newPhysicalRegisterTitle: "Novo Cliente",
      /********\
      *Recursos*
      \********/
      records: 0,
      personRemove: {},
      persons: [],
      person: {},
      isPhysical: false,
      physical: {
        address: {}
      },
      isEditing: false,
      tipos: ["Física", "Jurídica"],
      tipo: "",
      loadingCEP: false,
      isValidCnpj: false,
      cnpj: {},
      validCnpj: {contact:{}},
      legalDetails: {
        address: {}
      },
      emptySearchText: "Nenhum registro encontrado para",
      snackbar: {
        visible: false,
        title: "",
        subtitle: "",
        color: "",
        timeout: 6000
      },
      physicalDetails: {
        address: {}
      },
      /**********\
      ***Rules***
      \**********/
      inputRules: [
        v => !!v || 'Campo obrigatório',
      ],
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+/.test(v) || 'Insira um e-mail válido'
      ],


      /**********\
      *Data-Table*
      \**********/
      headers: [{
          text: "Nome",
          align: "center",
          value: "name"
        },
        {
          text: "Tipo",
          align: "center",
          sortable: false,
        },
        {
          text: "CPF / CNPJ",
          align: "center",
          value: "cpf",
          sortable: false,
        },
        {
          text: "E-mail",
          align: "center",
          value: "email"
        },
        {
          text: "Status",
          align: "center",
          value: "active"
        },
        {
          text: "",
          align: "center",
          sortable: false,
        }
      ]
    }),

    computed: {
      formTitle() {
        let text = "";
        if (this.isPhysical) text = this.isEditing ? this.editingLegalRegisterTitle : this.newLegalRegisterTitle;
        else text = this.isEditing ? this.editingPhysicalRegisterTitle : this.newPhysicalRegisterTitle;
        return text;
      },
      dynamicDetailsTitle() {
        let text = this.physical ? this.detailsTitlePhysical : this.detailsTitleLegal;
        return text;
      }
    },

    created() {
      this.initialize();
    },

    methods: {
      async findAddressByCep() {
        this.loadingCEP = true
        try {
          if (this.physical.address.cep && this.physical.address.cep.length == 8) {
            let address = await UtilService.findAddressByCep(this.physical.address.cep);
            this.physical.address = address
          }
        } catch (error) {
          this.snackbar.color = "error"
          this.snackbar.title = "CEP inválido!"
          this.snackbar.subtitle = "Repita a operação"
          this.snackbar.timeout = 6000
          this.snackbar.visible = true
        } finally {
          this.loadingCEP = false
        }
      },
      checkDuplicateRecord(person) {
        if (this.persons.length > 0) {
          for (const p of this.persons) {
            if (person.isLegalPerson == true) {
              if (p.cnpj && p.cnpj.replace(/[\.\-\/]/g, '') == person.cnpj.replace(/[\.\-\/]/g, '')) return true;
            } else {
              if (p.cpf && p.cpf.replace(/[\.\-\/]/g, '') == person.cpf.replace(/[\.\-\/]/g, '')) return true;
            }
          }
        }
        return false;
      },
      resetSnackbar() {
        this.snackbar.title = ""
        this.snackbar.color = ""
        this.snackbar.visible = false
        this.snackbar.timeout = 0
      },

      showSnackbar(msg, color, timeout) {
        if (this.snackbar.visible == true) this.resetSnackbar();
        this.snackbar.title = msg
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      calculateRecords() {
        let amount = 0;
        this.persons.forEach(p => amount++)
        this.records = amount;
      },

      /***************\
      *Setters/Getters*
      \***************/

      async initialize() {
        this.loading = true;
        try {
          this.closeDialog();
          this.persons = await PersonService.getAll();
          this.calculateRecords();
          this.disabledButtonSave = true;
        } catch (error) {
          this.clearResources();
          console.log(`Erro ao inicializar recursos : ${new Error(error)}`);
        } finally {
          this.loading = false;
        }
      },

      clearResources() {
        this.loading = true;
        try {
          this.person = {};
          this.physical = {
            address: {}
          };
          this.validCnpj = {};
          this.cnpj = {};
          this.isValidCnpj = false;
          this.isPhysical = -1;
          this.validationMessage = "";
          this.validationAlert = false;
          this.tipo = "";
        } catch (error) {
          console.log(`Erro ao limpar recursos : ${new Error(error)}`);
        } finally {
          this.loading = false;
        }
      },

      setPersonType() {
        if (this.tipo === "Física") {
          this.isPhysical = 0;
          this.disabledButtonSave = false;
        } else if (this.tipo === "Jurídica") {
          this.isPhysical = 1;
          this.disabledButtonSave = true;
        } else {
          this.isPhysical = -1;
        }
      },

      async searchCnpj() {
        this.loading = true;
        try {
          let cnpj = await PersonService.searchCnpj(this.cnpj);
       

          if (cnpj.cnpj) {
            this.validCnpj  = Converter.getPersonConverterFrom(
              cnpj
            );
   
            this.isValidCnpj = true;
            this.disabledButtonSave = false;
            this.validationMessage = "";
            this.validationAlert = false;
          } else {
            this.validationMessage = cnpj.message;
            this.validationAlert = true;
            return;
          }
        } catch (error) {
          this.clearResources();
          console.log(`Erro ao procurar CNPJ : ${new Error(error)}`);
        } finally {
          this.loading = false;
        }
      },

      /*******\
      *Dialogs*
      \*******/

      closeDialog(dialog) {
        this.loading = true;
        try {
          this.clearResources();
          if (this.isEditing) this.isEditing = false;
          switch (dialog) {
            case 'person':
              this.dialog = false;
              break;

            case 'details':
              this.physicalDetails = {
                address: {}
              };
              this.legalDetails = {
                address: {}
              };
              this.showDetails = false;
              break;

            default:
              this.dialog = false;
              this.dialogRemove = false;
              this.showDetails = false;
              this.physicalDetails = {
                address: {}
              };
              this.legalDetails = {
                address: {}
              };
              break;
          }
        } catch (error) {
          console.log(`Erro ao fechar dialog ${dialog} : ${new Error(error)}`);
        } finally {
          this.loading = false;
        }
      },

      details(item) {
        if (!item.address)
          item.address = {}

        if (item.isLegalPerson) {
          this.legalDetails = item;
          this.isPhysical = false;
        } else {
          this.physicalDetails = item;
          this.isPhysical = true;
        }
        this.showDetails = true;
      },

      /****\
      *CRUD*
      \****/

      edit(p) {
        if (!p.address)
          p.address = {}

        this.isEditing = true;
        this.disabledButtonSave = false;
        if (p.isLegalPerson) {
          this.validCnpj = Object.assign({}, p);
          this.isPhysical = 1;
          this.isValidCnpj = true;
          this.cnpj.cnpj = p.cnpj;
          this.tipo = "Jurídica";
        } else {
          this.isPhysical = 0;
          this.physical = Object.assign({}, p);
          this.tipo = "Física";
        }
        this.dialog = true;
      },

      async remove() {
        this.loading = true;
        try {
          await PersonService.remove(this.personRemove);
          this.initialize();
          this.showSnackbar("Excluído com sucesso!", null, "success", 5000);
        } catch (error) {
          this.showSnackbar("Erro ao excluir registro!", null, "error", 5000);
          console.log(`Erro ao excluir registro : ${new Error(error)}`);
        } finally {
          this.loading = false;
        }
      },

      async save() {
        if (this.$refs.form.validate()) {
          this.loading = true;

          try {
            if (this.isPhysical === 0) {
              this.person = this.physical;
              this.person.isLegalPerson = false;
            } else if (this.isPhysical === 1) {
              this.person = this.validCnpj;
              this.person.isLegalPerson = true;
            }
            if (this.person._id) {
              await PersonService.update(this.person);
              this.showSnackbar("Editado com sucesso!", "success", 5000);
            } else {
              if (this.checkDuplicateRecord(this.person)) {
                this.showSnackbar("Registro Duplicado!", "error", 5000);
              } else {
                await PersonService.save(this.person);
                this.showSnackbar("Salvo com sucesso!", "success", 5000);
              }
            }
            this.initialize();
          } catch (error) {
            console.log(error)
            this.showSnackbar("Erro ao salvar registro!", "error", 5000);
          } finally {
            this.loading = false;
          }
        }

      },

      //Validation Form
      validationForms() {
        if (this.$refs.form.validate()) {
          return true
        } else {
          return false
        }
      }
    }
  };

</script>

<style scoped>
  .actions-padding {
    padding-right: 18px;
    padding-bottom: 19px;
    padding-left: 18px;
  }

  .pt-switch {
    padding-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Person.vue